<template>
  <v-btn-form :title="title" @close="cancel()" listable>
      <v-card-text>
        <v-form v-model="valid">        
          <v-layout row wrap>
            <v-flex xs12 sm8> 
              <v-text-field 
              label="Адреса эл. почты" 
              hint="Введите адреса для рассылки документа"
              :rules="  emailRules"
              v-model="to"
              ></v-text-field>  
            </v-flex>  
            <v-flex xs12 sm4>
              <v-select
                label="Почтовый ящик" 
                hint="Выберите ящик из которого будет осуществляться рассылка"
                v-model="mailbox"
                :items="mailboxes"
                item-value="name"
                item-text="name"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm12> 
              <v-textarea 
              label="Тема" 
              hint="Тема письма с сылкой на документ"
              v-model="subject"
              rows="3"
              ></v-textarea>
            </v-flex>  
            <v-layout row>
              <v-flex xs5 sm6> 
                <v-select-check 
                v-model="options"
                :items="[{value: 'ATTACH', text: 'Прикрепить файлы', disabled: !model.uids}]"
                ></v-select-check>
              </v-flex>
              <v-flex xs5 sm4> 
                <v-date-field
                  placeholder="Сейчас"
                  v-model="scheduledDate"
                >
                </v-date-field>
                </v-flex>
                <v-flex xs2 sm2>  
                  <v-text-field
                    v-model="scheduledTime"
                    mask = "##:##"
                    :rules="[v => !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм']"
                  >
                  </v-text-field>
              </v-flex>
            </v-layout>
            <v-flex xs12 sm12>
              <v-html-field :value="this.text" @input="setText" :heightEditor="calcHeightEditor()" label="Сообщение"></v-html-field>
            </v-flex>
          </v-layout>
        </v-form>
        </v-card-text> 
    <template #actions>
      <v-btn @click="send" :disabled="!valid">Отправить</v-btn>
    </template>  
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import dialogs from '../common/dialogs'
  import depo from '../depo'
  import vSelectCheck from '../common/SelectCheck.vue'
  import vBtnForm from '../common/BtnForm'
  import vHtmlField from '../common/HtmlField'
  import vDateField from '../common/DateField.vue'
  import moment from 'moment'

  // import people from './index.js'

  export default {
    name: 'email-form',
    components: {vSelectCheck, vBtnForm, vHtmlField, vDateField},
    data: () => ({
      to: null,
      text: null,
      iframeWin: null,
      subject: null,
      options: null,
      scheduledDate: null,
      scheduledTime: null,
      mailbox: null,
      mailboxes: [],
      valid: false,
      emailRules: [
        v => !!v || 'Введите адреса электронной почты',
        v => formats.isEmails(v) || 'Неверный формат эл. почты'
      ]
    }),
    props: {
      model: {
        type: Object,
        default: () => ({uids: [], to: '', subject: '', options: '', body: '', signature: null, mailbox: null})
      },
      value: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Редактор почтового сообщения'
      }
    },
    created () {
    },
    mounted () {
      this.fetchData(this.model)
    },
    watch: {
      model: function (newValue) {
        this.fetchData(newValue)
      },
      options: function (newVal, oldVal) {
        if (oldVal !== null) {
          dialogs.confirm(this,
            'Внимание',
            `Текст письма будет создан заново, хорошо?`,
            (self) => {
              self.generateBody(self.model, newVal)
            })
        }
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      })
    },
    methods: {
      calcHeightEditor () {
        var height = 280 - 14 - 36
        return height + 'px'
      },
      cancel () {
        // this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      send () {
        let scheduled = null
        if (this.scheduledDate || this.scheduledTime) {
          let scheduledDate = this.scheduledDate || moment().format('YYYY-MM-DD')
          let scheduledTime = this.scheduledTime || moment().format('HHmm')
          scheduled = moment(`${scheduledDate} ${scheduledTime}`, 'YYYY-MM-DD HHmm', false)
        }
        let request = {email: this.to, subject: this.subject, body: this.text, uids: this.isAttach(this.options) ? this.model.uids : null, mailbox: this.mailbox, scheduled: scheduled && scheduled.isValid() && scheduled.format() || null, attach: this.isAttach(this.options)}
        this.$emit('change', request)
        this.cancel()
      },
      fetchData (model) {
        this.to = model.to
        if (!this.options) {
          this.options = model.options
          if (model.options && !model.options.toUpperCase().includes('ATTACH')) {
            this.options = 'ATTACH'
          }
        }
        this.subject = model.subject
        this.generateBody(model, this.options)
        this.$store.dispatch('getClientMailboxes').then(mbs => {
          this.mailboxes = mbs
          let name = model.mailbox
          if (name) {
            this.mailbox = mbs.reduce((accumulator, curValue) => curValue.name === name ? name : accumulator, '')
          } else {
            this.mailbox = mbs.length > 0 && mbs[0].name || ''
          }
        })
      },
      setText (value) {
        this.text = value
      },
      init (event) {
        this.iframeWin = event.target.contentWindow
      },
      isAttach (options) {
        return options && options.toUpperCase().includes('ATTACH')
      },
      generateBody (model, options) {
        this.$store.dispatch('getClientAccount').then(clientAccount => {
          if (!this.isAttach(options)) {
            depo.getPropsHtml(model.uids, model.body, model.subject, clientAccount.signature).then(data => {
              this.setText(data.body)
            })
          } else {
            this.setText(`${model.body}<br/>${clientAccount.signature}`)
          }
        })
      }
    }
  }

</script>




// WEBPACK FOOTER //
// EmailForm.vue?8acb781c